"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEvidenceItemRedirect = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const navigation_context_1 = require("../../navigation/navigation-context");
const evidence_types_1 = require("../evidence-types");
function useEvidenceItemRedirect() {
    const { id } = react_router_dom_1.useParams();
    const pathname = react_router_dom_1.useLocation().pathname;
    const { navigate } = react_1.useContext(navigation_context_1.NavigationContext);
    const base = pathname.substr(0, pathname.lastIndexOf('/'));
    react_1.useLayoutEffect(() => {
        if (id !== undefined) {
            navigate(base, true, {
                action: evidence_types_1.EvidenceStateAction.SHOW_ITEM,
                data: id,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
exports.useEvidenceItemRedirect = useEvidenceItemRedirect;
//# sourceMappingURL=item-redirect-hook.js.map